import { DocumentNode } from 'graphql';

import { CreateClientOrganizationModal } from './CreateClientOrganizationModal';
import { EditClientOrganizationModal } from './EditClientOrganizationModal';
import { GetClientOrganizationDocument } from './graphql/ClientOrganizationModal.generated';

export interface ClientOrganizationModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  organizationId: string | null;
  householdId: string;
  /** Callback to run after creating a new client organization that passes back the
   * new client organization id */
  onAfterCreate?: (newId: string) => void;
  /** Initially populate the organization name field with this value */
  initialOrganizationName?: string;
  /** After a mutation, the modal will trigger a refetch of the active queries.
   * Pass any queries you want to ignore from the refetch here. */
  ignoredQueryDocuments?: DocumentNode[];
  /** If the client organization was created from a suggestion, this is the ID of the suggestion */
  createdFromSuggestionID?: string;
}

export function ClientOrganizationModal({
  isOpen,
  setIsOpen,
  organizationId,
  householdId,
  onAfterCreate,
  initialOrganizationName,
  ignoredQueryDocuments,
  createdFromSuggestionID,
}: ClientOrganizationModalProps) {
  if (organizationId) {
    return (
      <EditClientOrganizationModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        organizationId={organizationId}
        householdId={householdId}
        ignoredQueryDocuments={[
          ...(ignoredQueryDocuments ?? []),
          GetClientOrganizationDocument,
        ]}
      />
    );
  }

  return (
    <CreateClientOrganizationModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      householdId={householdId}
      onAfterCreate={onAfterCreate}
      initialOrganizationName={initialOrganizationName}
      createdFromSuggestionID={createdFromSuggestionID}
    />
  );
}
